import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { units } from '../../../catalog/slice/units';

const Units = ({ prod, show }) => {
  const dispatch = useDispatch();
  const { id, hasAltItem, hasAltItem1, unit, altUnit, altUnit1 } = prod;

  const [activeUnit, setActiveUnit] = useState(unit);

  useEffect(() => {
    dispatch(units.actions.unit({ id, unit: activeUnit }));
  }, [id, activeUnit]);

  if (!show) {
    return <div className="wfd-price__per">&nbsp;</div>;
  }

  return (
    <div className="wfd-price__per">
      <p>Цена за</p>
      <ul>
        <li
          className={`${activeUnit === unit && 'wfd-price__act'}`}
          onClick={() => setActiveUnit(unit)}
        >
          {unit}
        </li>
        {hasAltItem && altUnit !== undefined && (
          <li
            className={`${activeUnit === altUnit && 'wfd-price__act'}`}
            onClick={() => setActiveUnit(altUnit)}
          >
            {altUnit}
          </li>
        )}
        {hasAltItem1 && altUnit1 !== undefined && (
          <li
            className={`${activeUnit === altUnit1 && 'wfd-price__act'}`}
            onClick={() => setActiveUnit(altUnit1)}
          >
            {altUnit1}
          </li>
        )}
      </ul>
    </div>
  );
};

export default Units;
